// extracted by mini-css-extract-plugin
module.exports = {"Container":"CenterForm_Container__3Ah0A","Title":"CenterForm_Title__10_Bp"};